module.exports = __webpack_public_path__ + "img/download dis.101151c6.svg";